export default __webpack_public_path__ + "static/media/lip-gloss.874b9421.png";